/** UI surface flags — catalogofworks brand. Shared by Vite (via @brand) and Node registry. */
export const PRODUCT_FEATURES = {
  registeredClients: false,
  telegramIntegration: true,
  stockManagement: false,
};

export const PRODUCT_AVAILABILITY_STATUSES = [
  'in_stock',
  'out_of_stock',
  'on_order',
];

export const EXTENSION_GATED_MODULE_KEYS = new Set(['publisher', 'export', 'albums', 'visiting_card']);

export const HIDDEN_TENANT_MODULE_KEYS = new Set([
  ...(PRODUCT_FEATURES.registeredClients ? [] : ['crm']),
  ...(PRODUCT_FEATURES.stockManagement ? [] : ['stock', 'stock_alerts']),
  ...EXTENSION_GATED_MODULE_KEYS,
]);

export function isSettingsTabDisabled(tab) {
  if (tab === 'clients') {
    return !PRODUCT_FEATURES.registeredClients;
  }
  if (tab === 'telegram') {
    return !PRODUCT_FEATURES.telegramIntegration;
  }
  if (tab === 'stock') {
    return !PRODUCT_FEATURES.stockManagement;
  }
  return false;
}

export const HIDDEN_IMPORT_MODES = new Set([
  ...(PRODUCT_FEATURES.stockManagement ? [] : ['stock']),
  ...(PRODUCT_FEATURES.registeredClients ? [] : ['clients']),
]);

export function isImportModeVisible(mode) {
  return !HIDDEN_IMPORT_MODES.has(mode);
}
